
import { Component, Vue, Watch } from 'vue-property-decorator';
import CreateWorkspace from "../models/CreateWorkspace";
import VatWarning from "../components/shared/VatWarning.vue";
import { GraphUserModel } from "../models/GraphUserModel";
import { Template } from '../models/Template';
import { validationMixin } from 'vuelidate';
import { required, minLength, alphaNum, maxLength, numeric } from 'vuelidate/lib/validators';
import { Workspace } from '../models/Workspace';
import Datepicker from 'vuejs-datepicker';
import { mapState } from 'vuex';
import { AddWorkspacesParams, GetWorkspacesParams } from '@/models/StoreClasses'
import { Dictionary } from 'vue-router/types/router';
import { Helper } from "../models/HelperClasses";
import { errorToaster } from '@/data/ajax';
import { VreConfiguration } from '@/models/VreConfiguration';

Component.registerHooks(["validations"])

@Component({
  mixins:[validationMixin],
  components:{Datepicker, VatWarning},
  computed: mapState(["workspaces", "vreConfiguration"])
})


export default class WorkspaceUpdate extends Vue{
  createWorkspace: CreateWorkspace = new CreateWorkspace();
  submitted: boolean = false; 
  $v: any; //vuelidate
  private renewalPeriods: string[] = ['Monthly', 'Quarterly', 'Annually'];
  public $appInsights: any; //set by library
  public workspaces!: Dictionary<Workspace[]> //Is assigned via mapstate
  public vreConfiguration!: VreConfiguration //Is assigned via mapstate
  public selectedWorkspace!: Workspace;
  public headerInformation: string = "";

  validations(){
    return{
      createWorkspace: {
        description: {
          required,
          maxLength: maxLength(1000 - 33 - 23 - this.createWorkspace.previousRequest.length) //1000 is database max length, 33 is extra text, see CreateWorkspace.ts, 23 is approval portal issues
        },
        budget:{
          required,
          numeric,
          minValue: (value: number) => value > 0
        },
        endDate:{
          required,
          minValue: (value: Date) => value > new Date()
        },
        costcenter:{
          required: (value: string) => {
            //new format
            var splitValue = value.split('-');
            if(splitValue.length === 2 && splitValue[0].length === 8 && splitValue[1].length === 2 && !isNaN(Number(splitValue[0])) && !isNaN(Number(splitValue[1]))){
              return true;
            }
            return false;
          }
        }
      }
    }
  }
  get budgetIncludingSurcharge(){
    return this.formatMoney((parseInt(this.createWorkspace.budget)* (this.vreConfiguration.surfToeslag / 100 + 1))*1.21);
  }

  formatMoney(money: number){
    money = parseFloat(money.toString());
    return Helper.formatMoney(money);
  }

  async save() {
    this.$v.$touch();
    if(!this.$v.$invalid){
      this.submitted = true;
      var token = await this.$store.state.authModule.getapiTokenPopup();
      var result = await this.createWorkspace.update(this.$route.params.workspaceId, token);
      if(result !== null){
        this.$store.commit("setToaster", `You have succesfully requested an update for workspace ${this.createWorkspace.name}. Your request is submitted to the budget holder and is pending approval.`);
        this.selectedWorkspace.budgetStatus = "Requested";
        let key = `workspaces|${this.$store.state.authModule.userName}`;
        var params = new AddWorkspacesParams(key,this.workspaces[key]);
        this.$store.commit('addWorkspaces', params);
        this.$router.push("/");
      } else {
        this.submitted = false;
      }
    }
   }

  async created(){
    let getWorkspacesParams = new GetWorkspacesParams(this.$store.state.authModule.userName, false)
    await this.$store.dispatch("getWorkspaces", getWorkspacesParams);
    let key = `workspaces|${this.$store.state.authModule.userName}`;
    var userWorkspaces = this.workspaces[key];
    var selectedWorkspace = userWorkspaces.find((ws) => {
      return ws.workspaceId === this.$route.params.workspaceId;
    });
    if(!selectedWorkspace){
      throw "Could not find workspace with workspaceId " + this.$route.params.workspaceId;
      return;
    }
    this.selectedWorkspace = selectedWorkspace;

    this.createWorkspace = new CreateWorkspace();
    this.createWorkspace.name = selectedWorkspace.name;
    this.createWorkspace.ownerEmail = selectedWorkspace.ownerEmail;
    this.createWorkspace.previousRequest = `On ${Helper.formatDate(selectedWorkspace.budgetLastApprovedOn)} the budget holder of ${selectedWorkspace.costcenter} has approved a workspace budget of ${Helper.formatMoney(selectedWorkspace.budget)} to be spent on Azure resources. At ${Helper.formatDate(new Date())} ${Helper.formatMoney(selectedWorkspace.currentSpend)} of this workspace budget was spent.`;
    this.createWorkspace.endDate = new Date(new Date().getFullYear(), 11, 31, 23, 59);
    if(new Date(this.selectedWorkspace.budgetExpirationDate).getUTCFullYear() >= this.createWorkspace.endDate.getUTCFullYear()){
      //Budgetupdate
      this.headerInformation = "With this form you can request additional budget for the current year."
    } else {
      //Budget reset
      this.headerInformation = "Last year's budget has expired. With this form you can request a new budget for this year. After approval, by budget holder, this budget is set as the new budget limit for your workspace. The budget counter is reset."
    }
  }
}
